<div class="list-entry"
  *ngIf="listEntry"
  [class.has-background]="listEntry.icon && imageLoaded"
  [class.loading-bg]="listEntry.icon && !imageLoaded"
  [style.background-image]="listEntry.icon && imageLoaded ? 'url(' + listEntry.icon + ')' : 'none'"
  (click)="onClick()">

  <!-- Preload oculto para disparar imageLoaded -->
  <img *ngIf="listEntry.icon" [src]="listEntry.icon" (load)="onImageLoad()" style="display:none" />

  <!-- Shimmer mientras carga la imagen -->
  <div class="list-shimmer" *ngIf="listEntry.icon && !imageLoaded"></div>

  <!-- Overlay degradado cuando hay imagen -->
  <div class="list-overlay" *ngIf="listEntry.icon && imageLoaded"></div>

  <!-- Contenido -->
  <div class="list-content">

    <!-- Info principal -->
    <div class="list-info">
      <span class="list-name">{{ listEntry.name }}</span>
      <span class="list-meta">
        {{ listTypeLabel }}
        <ng-container *ngIf="listEntry.ownerInfo?.name">
          &nbsp;&middot;&nbsp;{{ listEntry.ownerInfo!.name }}
          <img *ngIf="listEntry.ownerInfo!.verified" src="/assets/verified.png" class="verified-icon" />
        </ng-container>
      </span>
    </div>

  </div>
</div>
